<template>
  <el-dialog :visible.sync="dialogVisible" width="680px" title="修改时间段" :append-to-body="true">
    <DragWeektime v-model="timeSchedule" :data="weektimeData"></DragWeektime>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onBatchModifyCancel">取 消</el-button>
      <el-button type="primary" :disabled="!timeSchedule" @click="onBatchModifyConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { ref, computed, toRef } from 'vue'
import weektimeData from '@/data/tencent/weektime_data'
import DragWeektime from '@/views/edit/kuaishou/components/time-range/index.vue'
// eslint-disable-next-line
const props = defineProps({ value: Boolean, title: String })
// eslint-disable-next-line
const emit = defineEmits(['input', 'confirm'])
const visible = toRef(props, 'value')
const dialogVisible = computed({
  get() {
    return visible.value
  },
  set(v) {
    emit('input', v)
  }
})

const timeSchedule = ref('')

function onBatchModifyConfirm() {
  emit('confirm', timeSchedule.value)
  dialogVisible.value = false
  timeSchedule.value = ''
}
function onBatchModifyCancel() {
  dialogVisible.value = false
}
</script>

<style lang="scss" scoped>
</style>
